import { UseFormReturn } from 'react-hook-form';

import { Flex, Grid } from 'components/layout';
import { Typography } from 'components/typography';
import { LTLItem } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { TMS } from 'types/enums/Integrations';

import { QuickQuoteInputs } from '../../types';
import { LTLLinearFeetInput } from '../LTLLinearFeetInput';
import { LTLShipmentStackingAndSideLoadControls } from '../components/LTLShipmentStackingAndSideLoadControls';

interface CommoditySectionProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
  replaceItems?: (items: LTLItem[]) => void;
}

// LTL options: stackable, side-loading, and linear feet.
export function CommoditySection({
  formMethods,
  replaceItems,
}: CommoditySectionProps) {
  return (
    <Flex direction='col' gap='lg' className='w-full mx-0'>
      <Typography
        variant='h5'
        className='text-neutral-800 font-semibold whitespace-nowrap'
      >
        Options
      </Typography>

      <Grid cols='1' gap='lg' align='end' className='w-full mx-0'>
        <LTLShipmentStackingAndSideLoadControls
          formMethods={formMethods}
          showStackable={true}
        />
      </Grid>

      <LTLLinearFeetInput
        formMethods={formMethods}
        integrationName={TMS.Turvo}
        replaceItems={replaceItems}
      />
    </Flex>
  );
}
